import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const LoadingFallback = ({ message = 'Loading...' }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: '2rem',
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '3px solid #f3f3f3',
      borderTop: '3px solid #8c1428',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '1rem',
    }} />
    <Typography variant="body1" color="textSecondary">
      {message}
    </Typography>

    <style>{`
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `}</style>
  </div>
);

LoadingFallback.propTypes = {
  message: PropTypes.string,
};

export default LoadingFallback;
